import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon, theme } from '@sweetgreen/garnish';

export const HomeScreenMobileHeader = () => {
  return (
    <View testID="home.mobile-header" style={styles.row}>
      <Icon
        name="IconSweetgreen"
        color={theme.colors.KALE}
        width={40}
        height={40}
      />
    </View>
  );
};

// ─── Styles ───────────────────────────────────────────────────────

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 56,
  },
});
